import React from 'react';
import PropTypes from 'prop-types';
import { openTab } from '../../../src/utils/openTab';
import OTPAwardBadge from '../../../static/images/OTPAwardBadge.png';
import FSFlatButton from '../../../src/components/lib/FSFlatButton';

const OTPAwardsLink = 'https://www.flightstats.com/company/media/on-time-performance-awards/';

const OTPWinnerSection = (props) => {
  const {
    reportButtonPress,
  } = props;

  return (
    <div className='homepage-otp-award-winner-section'>
      <div className='homepage-otp-award-winner-section-left-col'>
        <div
          className='homepage-otp-award-winner-section-badge'
          style={{ backgroundImage: `url(${OTPAwardBadge})` }}
        />
      </div>
      <div className='homepage-otp-award-winner-section-right-col'>
        <div className='homepage-otp-award-winner-text-container'>
          <h2>9th Annual</h2>
          <h3>On-time Performance Service Awards</h3>
          <h4>Continuing the tradition of celebrating airline success</h4>
        </div>
        <div className='homepage-otp-award-winner-button-container'>
          <FSFlatButton
            label='See 2017 Winners'
            onClick={() => {
              reportButtonPress('OTP2017Winners');
              openTab(OTPAwardsLink);
            }}
          />
        </div>
      </div>
    </div>
  );
};

OTPWinnerSection.propTypes = {
  reportButtonPress: PropTypes.func,
};

export default OTPWinnerSection;



// WEBPACK FOOTER //
// ./modules/Homepage/components/OTPWinnerSection.js